import styled, { css, keyframes } from 'styled-components';

// «Сердцебиение» (lub-dub) при добавлении.
const heartbeat = keyframes`
    0%   { transform: scale(1); }
    15%  { transform: scale(1.3); }
    30%  { transform: scale(1); }
    45%  { transform: scale(1.18); }
    60%  { transform: scale(0.94); }
    78%  { transform: scale(1.06); }
    100% { transform: scale(1); }
`;

export const IconBeat = styled.span<{ $beat: boolean }>`
    display: inline-flex;
    will-change: transform;

    ${(p) => p.$beat && css`
        animation: ${heartbeat} 0.7s cubic-bezier(0.28, 0.84, 0.42, 1);
    `}

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

// «Разбитое сердце» при удалении: красные половинки разлетаются вниз, снизу
// остаётся белое сердце.
const breakLeft = keyframes`
    0%   { transform: translate(0, 0) rotate(0deg); opacity: 1; }
    22%  { transform: translate(-8%, -4%) rotate(-6deg); opacity: 1; }
    100% { transform: translate(-48%, 62%) rotate(-34deg); opacity: 0; }
`;

const breakRight = keyframes`
    0%   { transform: translate(0, 0) rotate(0deg); opacity: 1; }
    22%  { transform: translate(8%, -4%) rotate(6deg); opacity: 1; }
    100% { transform: translate(48%, 62%) rotate(34deg); opacity: 0; }
`;

export const BreakOverlay = styled.span`
    position: absolute;
    inset: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;

const halfBase = css`
    position: absolute;
    display: inline-flex;
`;

// clip-path — рваный вертикальный шов по центру (левая/правая комплементарны).
export const HalfLeft = styled.span`
    ${halfBase};
    clip-path: polygon(0% 0%, 52% 0%, 44% 18%, 56% 36%, 43% 54%, 55% 72%, 45% 90%, 50% 100%, 0% 100%);
    animation: ${breakLeft} 0.6s cubic-bezier(0.36, 0, 0.66, -0.2) forwards;
`;

export const HalfRight = styled.span`
    ${halfBase};
    clip-path: polygon(52% 0%, 100% 0%, 100% 100%, 50% 100%, 45% 90%, 55% 72%, 43% 54%, 56% 36%, 44% 18%);
    animation: ${breakRight} 0.6s cubic-bezier(0.36, 0, 0.66, -0.2) forwards;
`;
